import React, { useMemo } from 'react';
import { Button, NumberField, StyledWrapper, TextField } from 'ui-toolkit';
import { Form, Formik } from 'formik';
import { IEscrowActualIncomingCheckQuery } from 'types/accounting/query/IEscrowActualIncomingCheckQuery';
import { DateRangeFilter } from 'ui-toolkit/components/DataGrid/DateRangeFilter';
import { StyledTableRow } from './MatchedActualStyles';

interface IMatchActualCheckDepositSearchBarProps {
  setQuery: (query: IEscrowActualIncomingCheckQuery) => void;
  query: IEscrowActualIncomingCheckQuery;
}
export const MatchActualCheckDepositSearchBar: React.FC<IMatchActualCheckDepositSearchBarProps> = ({
  setQuery,
  query,
}) => {
  const initialValues = useMemo(() => {
    return {
      createdAtDate: query.completedAtDate,
      checkIdentifier: query.checkIdentifier,
      checkDetail: query.checkDetail,
      received: query.amountCents,
      unmatched: query.unmatchedAmountCents,
    };
  }, [query]);

  const onSubmit = (values: any) =>
    setQuery({
      ...query,
      completedAtDate: values.createdAtDate ?? undefined,
      checkIdentifier: values.checkIdentifier ?? undefined,
      checkDetail: values.checkDetail ?? undefined,
      amountCents: values.received ?? undefined,
      unmatchedAmountCents: values.unmatched ?? undefined,
    });

  const updateDateRange = (newDate: any, setFieldValue: any) => {
    setFieldValue('createdAtDate', newDate);
  };

  return (
    <StyledWrapper>
      <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
        {({ handleSubmit, values, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <StyledTableRow columnsLength={6}>
              <DateRangeFilter
                defaultValue={values.createdAtDate}
                onFilter={(value) => updateDateRange(value, setFieldValue)}
                showClear
                fixed
              />
              <TextField name={`checkIdentifier`} placeholder={'Check Identifier'} />
              <TextField name={`checkDetail`} placeholder={'Check Detail'} />
              <NumberField name={`received`} mode="currency" placeholder="Received" valueIsCents />
              <NumberField name={`unmatched`} mode="currency" placeholder="Unmatched" valueIsCents />
              <Button intent={'primary'} type={'submit'} data-test-id={`search-button`}>
                Search
              </Button>
            </StyledTableRow>
          </Form>
        )}
      </Formik>
    </StyledWrapper>
  );
};
